<template>
  <b-container>
    <section v-if="!isEdit"><h1 class="text-left mb-5">Új csoport létrehozása</h1></section>

    <section v-else><h1 class="text-left mb-5">Csoport szerkesztése</h1></section>

    <FormSectionContainer index="1" title="Csoport nevének megadása">
      <b-row>
        <b-col cols="12" class="mb-3">
          <label for="groupName">Csoport nevének megadása<span class="required-star"></span></label>
          <b-form-input
            id="groupName"
            v-model="groupName"
            placeholder="Adja meg a csoport nevét"
            trim
            :state="groupNameState"
            :class="`${groupNameState !== null && !groupNameState ? 'user-group-error-border' : ''}`"
          ></b-form-input>

          <b-form-invalid-feedback class="user-group-error-message" id="input-live-feedback">
            Adja meg a címzett csoport nevét.
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
    </FormSectionContainer>

    <FormSectionContainer
      index="2"
      title="Összetett feltételek"
      :key="
        emailFilters.selectedComplexFilters.length > 0
          ? emailFilters.selectedComplexFilters[0]
          : 'selectedComplexFilters'
      "
    >
      <ComplexFilterSelector
        @new-selected-complex-filters="handleComplexFiltersSelection"
        :complexFilters="complexFilters"
        :preSelection="emailFilters.selectedComplexFilters"
      />
    </FormSectionContainer>

    <FormSectionContainer
      index="3"
      title="Tevékenységi kód szerinti szűrőfeltétel megadása"
      :key="
        this.emailFilters.selectedTwoDigitTeaors
          ? this.emailFilters.selectedTwoDigitTeaors[0]
          : this.emailFilters.selectedThreeDigitTeaors
          ? this.emailFilters.selectedThreeDigitTeaors[0]
          : this.emailFilters.selectedFourDigitTeaors
          ? this.emailFilters.selectedFourDigitTeaors[0]
          : 'teaor'
      "
    >
      <b-form-group class="text-left">
        <b-row style="margin-top:10px;">
          <b-col class="radio-box" style="margin-left: 15px; ">
            <input type="radio" id="twoDigit" value="twoDigit" v-model="teaorType" />
            <label class="radio-text" for="twoDigit">Tevékenységkód megadása (Kétjegyű)</label>
          </b-col>
          <b-col cols="12" md="6" lg="6" xl="6">
            <MultipleTeaorSelect
              :disabled="teaorType !== 'twoDigit'"
              listType="twoDigit"
              :alreadySelected="emailFilters.selectedTwoDigitTeaors"
              title="Tevékenységkód megadása (Kétjegyű)"
              @selected-other-teaors="handleTwoDigitTeaorSelect($event)"
            />
          </b-col>
        </b-row>
        <b-row style="margin-top:10px;">
          <b-col class="radio-box" style="margin-left: 15px; ">
            <input type="radio" id="threeDigit" value="threeDigit" v-model="teaorType" />
            <label class="radio-text" for="threeDigit">Tevékenységkód megadása (Háromjegyű)</label>
          </b-col>
          <b-col cols="12" md="6" lg="6" xl="6">
            <MultipleTeaorSelect
              :disabled="teaorType !== 'threeDigit'"
              listType="threeDigit"
              :alreadySelected="emailFilters.selectedThreeDigitTeaors"
              title="Tevékenységkód megadása (Háromjegyű)"
              @selected-other-teaors="handleThreeDigitTeaorSelect($event)"
            />
          </b-col>
        </b-row>
        <b-row style="margin-top:10px;">
          <b-col class="radio-box" style="margin-left: 15px; ">
            <input type="radio" id="fourDigit" value="fourDigit" v-model="teaorType" />
            <label class="radio-text" for="fourDigit">Tevékenységkód megadása (Négyjegyű)</label>
          </b-col>
          <b-col cols="12" md="6" lg="6" xl="6">
            <MultipleTeaorSelect
              listType="fourDigit"
              :disabled="teaorType !== 'fourDigit'"
              :alreadySelected="emailFilters.selectedFourDigitTeaors"
              title="Tevékenységkód megadása (Négyjegyű)"
              @selected-other-teaors="handleFourDigitTeaorSelect($event)"
            />
          </b-col>
        </b-row>
      </b-form-group>
    </FormSectionContainer>

    <FormSectionContainer
      index="4"
      title="Megvalósítás helye szerinti feltétel megadása"
      :key="emailFilters.selectedZips ? emailFilters.selectedZips[0] : 'selectedZips'"
    >
      <b-col>
        <MultipleZipSelect
          @selected-other-zips="handleZipSelect($event)"
          :alreadySelected="emailFilters.selectedZips"
        />
      </b-col>
    </FormSectionContainer>

    <FormSectionContainer
      index="5"
      title="Csoport további szűrőfeltéleinek megadása"
      :key="emailFilters.selectedGfos ? emailFilters.selectedGfos[0] : 'selectedGfos'"
    >
      <b-row>
        <MultipleSelect
          :options="this.gfoList"
          label="Megengedett cégformák"
          placeholder="Válasszon cégformákat"
          @on-item-select="handleGfoSelect($event)"
          :preSelection="emailFilters.selectedGfos"
        />
      </b-row>

      <b-row>
        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.minHeadCount">Minimum létszám</label>
          <div class="input-symbol-person">
            <b-form-input
              id="emailFilters.minHeadCount"
              v-model="emailFilters.minHeadCount"
              @keypress="isNumber($event, false)"
              placeholder="Adja meg az elvárt létszám minimumát"
              trim
            ></b-form-input>
          </div>
        </b-col>
        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.maxHeadCount">Maximum létszám</label>
          <div class="input-symbol-person">
            <b-form-input
              id="emailFilters.maxHeadCount"
              v-model="emailFilters.maxHeadCount"
              @keypress="isNumber($event, false)"
              placeholder="Adja meg az elvárt létszám maximumát"
              trim
            ></b-form-input>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.minBalanceSheetTotal">Mérlegfőösszeg minimum mértéke</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="emailFilters.minBalanceSheetTotal"
              v-model="emailFilters.minBalanceSheetTotal"
              @keypress="isNumber($event, true)"
              placeholder="Mérlegfőösszeg minimum mértéke"
              trim
            ></b-form-input>
          </div>
        </b-col>

        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.maxBalanceSheetTotal">Mérlegfőösszeg maximum mértéke</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="emailFilters.maxBalanceSheetTotal"
              v-model="emailFilters.maxBalanceSheetTotal"
              @keypress="isNumber($event, true)"
              placeholder="Mérlegfőösszeg maximum mértéke"
              trim
            ></b-form-input>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.minIncome">Minimum nettó árbevétel</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="emailFilters.minIncome"
              v-model="emailFilters.minIncome"
              @keypress="isNumber($event, true)"
              placeholder="Adja meg az elvárt nettó árbevétel minimumát"
              trim
            ></b-form-input>
          </div>
        </b-col>
        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.maxIncome">Maximum nettó árbevétel</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="emailFilters.maxIncome"
              v-model="emailFilters.maxIncome"
              @keypress="isNumber($event, true)"
              placeholder="Adja meg az elvárt nettó árbevétel maximumát"
              trim
            ></b-form-input>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.minExport">Export minimum mértéke</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="emailFilters.minExport"
              v-model="emailFilters.minExport"
              @keypress="isNumber($event, true)"
              placeholder="Minimum árbevétel mértéke"
              trim
            ></b-form-input>
          </div>
        </b-col>

        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.maxExport">Export maximum mértéke</label>
          <div class="input-symbol-forint">
            <b-form-input
              id="emailFilters.maxExport"
              v-model="emailFilters.maxExport"
              @keypress="isNumber($event, true)"
              placeholder="Maximum árbevétel mértéke"
              trim
            ></b-form-input>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.closedBusinessYears">Minimum lezárt üzleti évek száma</label>
          <div class="input-symbol-year">
            <b-form-input
              id="emailFilters.closedBusinessYears"
              v-model="emailFilters.closedBusinessYears"
              @keypress="isNumber($event, true)"
              placeholder="Minimum lezárt üzleti évek száma"
              trim
              class="mb-2"
            ></b-form-input>
          </div>
        </b-col>

        <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-3">
          <label for="emailFilters.exportPercent">Export minimum százalék</label>
          <div class="input-symbol-percent">
            <b-form-input
              id="emailFilters.exportPercent"
              v-model="emailFilters.exportPercent"
              @keypress="isNumber($event, true)"
              placeholder="Export minimum százalék"
              trim
            ></b-form-input>
          </div>
        </b-col>
      </b-row>
    </FormSectionContainer>
    <b-col cols="12" class="d-flex justify-content-start">
      <b-button @click="navigateTo('/system-email/home')" class="mr-2">Vissza</b-button>
      <b-button @click="saveGroup" variant="primary">Csoport mentése</b-button>
    </b-col>
  </b-container>
</template>

<script>
import * as systemEmailsApi from '../../api/systemEmail'
import FormSectionContainer from '../FundCreation/components/FormSectionContainer.vue'
import MultipleSelect from '../../components/MultipleSelect.vue'
import { gfoOptions } from '../FundCreation/utils/gfoOptions'
import successToast from '../../mixins/toastSuccess'
import errorToast from '../../mixins/toastError'
import MultipleTeaorSelect from '../FundMap/components/MultipleTeaorSelect.vue'
import MultipleZipSelect from '../FundMap/components/MultipleZipSelect.vue'
import ComplexFilterSelector from '../FundCreation/components/ComplexFiltersSelector.vue'
import * as ComplexFilterApi from '../../api/complexFilter'
export default {
  mixins: [successToast, errorToast],
  data() {
    return {
      groupName: '',
      gfoList: gfoOptions,
      complexFilters: [],
      emailFilters: {
        selectedComplexFilters: [],
        selectedTwoDigitTeaors: [],
        selectedThreeDigitTeaors: [],
        selectedFourDigitTeaors: [],
        selectedZips: [],
        selectedGfos: [],
        minHeadCount: '',
        maxHeadCount: '',
        minBalanceSheetTotal: '',
        maxBalanceSheetTotal: '',
        minIncome: '',
        maxIncome: '',
        minExport: '',
        maxExport: '',
        closedBusinessYears: '',
        exportPercent: ''
      },
      isEdit: false,
      touched: false,
      teaorType: 'twoDigit'
    }
  },
  computed: {
    groupNameState() {
      if (this.touched) {
        return this.groupName !== ''
      } else {
        return null
      }
    }
  },
  components: { FormSectionContainer, MultipleSelect, MultipleTeaorSelect, MultipleZipSelect, ComplexFilterSelector },
  methods: {
    isNumber(evt, isMinusAllowed) {
      const isStarting0Allowed = !this.$route.path.includes('/create-fund')
      const input = evt.target.value
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
      const keyPressed = evt.key

      if (keyPressed === '-' && input.length === 0 && isMinusAllowed) {
        return
      }

      if (input.length === 0 && keyPressed === '0' && isStarting0Allowed) {
        evt.preventDefault()
        return
      }

      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    navigateTo(link) {
      this.$router.push(link)
    },
    async saveGroup() {
      const { groupId } = this.$route.query

      if (!this.touched) {
        this.touched = true
      }
      if (this.groupName !== '') {
        if (this.isEdit) {
          try {
            await systemEmailsApi.patchUserGroupById(groupId, this.groupName, this.emailFilters)

            this.onSucces()
          } catch (e) {
            this.onError()
            console.log(e)
          }
        } else {
          try {
            await systemEmailsApi.createUserGroup(this.groupName, this.emailFilters)

            this.onSucces()
          } catch (e) {
            this.onError()
            console.log(e)
          }
        }
      } else {
        this.errorToast('A továbblépéshez töltse ki a megjelölt mezőket!')
      }
    },
    handleComplexFiltersSelection(complexFilters) {
      this.emailFilters.selectedComplexFilters = complexFilters
    },
    handleGfoSelect(value) {
      this.emailFilters.selectedGfos = value
    },
    handleTwoDigitTeaorSelect(twoDigitTeaorArray) {
      this.emailFilters.selectedTwoDigitTeaors = twoDigitTeaorArray
    },
    handleThreeDigitTeaorSelect(threeDigitTeaorArray) {
      this.emailFilters.selectedThreeDigitTeaors = threeDigitTeaorArray
    },
    handleFourDigitTeaorSelect(fourDigitTeaorArray) {
      this.emailFilters.selectedFourDigitTeaors = fourDigitTeaorArray
    },
    handleZipSelect(zipArray) {
      this.emailFilters.selectedZips = zipArray
    },
    async getComplexFilters() {
      try {
        this.complexFilters = await ComplexFilterApi.listComplexFilters()
      } catch (e) {
        console.log(e)
      }
    },
    onSucces() {
      this.successToast('A mentés sikeres volt!')
      setTimeout(() => {
        this.$router.push('/system-email/home')
      }, 1000)
    },
    onError() {
      this.errorToast('A továbblépéshez töltse ki a megjelölt mezőket!')
    }
  },
  watch: {
    teaorType() {
      if (this.teaorType === 'twoDigit') {
        delete this.emailFilters['selectedThreeDigitTeaors']
        delete this.emailFilters['selectedFourDigitTeaors']
      }
      if (this.teaorType === 'threeDigit') {
        delete this.emailFilters['selectedTwoDigitTeaors']
        delete this.emailFilters['selectedFourDigitTeaors']
      }
      if (this.teaorType === 'fourDigit') {
        delete this.emailFilters['selectedTwoDigitTeaors']
        delete this.emailFilters['selectedThreeDigitTeaors']
      }
    }
  },
  async created() {
    this.getComplexFilters()

    const { groupId } = this.$route.query
    if (groupId) {
      this.isEdit = true

      try {
        const result = await systemEmailsApi.getUserGroupById(groupId)
        this.groupName = result.groupName
        this.emailFilters = result.emailFilters

        if (this.emailFilters.selectedTwoDigitTeaors && this.emailFilters.selectedTwoDigitTeaors.length > 0) {
          this.teaorType = 'twoDigit'
        }
        if (this.emailFilters.selectedThreeDigitTeaors && this.emailFilters.selectedThreeDigitTeaors.length > 0) {
          this.teaorType = 'threeDigit'
        }
        if (this.emailFilters.selectedFourDigitTeaors && this.emailFilters.selectedFourDigitTeaors.length > 0) {
          this.teaorType = 'fourDigit'
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-group-error-border {
  border: 2px solid #ba3b46 !important;
}

.user-group-error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 14px;
}

.radio-text {
  font-weight: 400;
  font-size: 14px;
  color: #2d3436;
  text-transform: none;
}

input[type='radio'] {
  width: 20px;
  height: 20px;
  border: 1px solid #bbc1d3;
}

input[type='radio']:after {
  border-radius: 20px;
  content: '';
  display: inline-block;
}

input[type='radio']:checked:after {
  width: 20px;
  height: 20px;
  background-color: white;
  border: 6px solid #00903c;
}
.radio-box {
  display: flex;
  padding-top: 10px;
}
</style>
